import Price from "@/app/components/lib/Price";
import AddonQuantitySelector from "../addon-quantity-selector/AddonQuantitySelector";
import { useTranslation } from "@/hooks/localization/useTranslations";

export type QuantityContor = {
  quantity: number;
  setQuantity: (quantity: number) => void;
  plusDisabled: boolean;
  minQuantity: number;
};
interface IPriceQuantity {
  price?: number;
  quantityContor?: QuantityContor;
  checked: boolean;
  flexColumn?: boolean;
  outOfStock: boolean;
  disabled?: boolean;
  is_multi_select: boolean;
}
const PriceQuantity: React.FC<IPriceQuantity> = ({
  price,
  quantityContor,
  checked,
  flexColumn,
  outOfStock,
  disabled,
  is_multi_select,
}) => {
  const { quantity, setQuantity, plusDisabled, minQuantity } =
    quantityContor ?? {};
  const t = useTranslation();
  return (
    <div
      className={`price-qyantity-section ${flexColumn ? "flex-column" : ""} ${
        (checked && quantityContor) || outOfStock ? "w-100" : ""
      }`}
    >
      {outOfStock && <p className="m-0">{t.out_of_stock}</p>}
      {quantityContor && checked && (
        <AddonQuantitySelector
          quantity={quantity!}
          setQuantity={setQuantity!}
          plusDisabled={plusDisabled!}
          flexColumn={flexColumn}
          minQuantity={minQuantity}
          disabled={disabled}
          is_multi_select={is_multi_select}
        />
      )}
      {!!price && <Price price={{ value: price }} roundPrice />}
    </div>
  );
};

export default PriceQuantity;
